import React, { useState, useEffect, useRef } from "react";
import printIcon from "../../../../../assets/print-icon.svg";
import dropdownIcon from "../../../../../assets/dropdown.svg";
import CustomSelect from "../../../../../Util/CustomSelect/CustomSelect";
import "./MasterSchedule.css";
import SimpleBarReact from "simplebar-react";
import axiosApi from "../../../../../core/interceptor/interceptor";
import { config } from "../../../../../config";
import _ from "lodash";
import { COLORS } from '../../../../../Util/helper';
import SortableList, { SortableItem } from "react-easy-sort";
import moment from "moment";
import ReactToPrint from "react-to-print";
import { toast } from "react-toast";
import MasterSchedulePrint from "./MasterSchedulePrint";
import WarningDialogue from "../../../../../Util/WarningDialogue";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

export default function MasterSchedule() {
  let defaultFilter = {
    sport: { id: 0, title: 'Sport' },
    season: { id: 0, title: 'Season' },
    week: { id: 0, title: 'Week' },
  }
  const [sportsList, setSportsList] = useState([]);
  const [seasonsList, setSeasonsList] = useState([]);
  const [weekList, setWeekList] = useState([]);
  const [roundList, setRoundList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [locationDropdownOpen, setLocationDropdownOpen] = useState(false);
  const [dateList, setDateList] = useState([]);
  const [leagueIds, setLeagueIds] = useState([]);
  let originalSeasons = [];
  const [filter, setFilter] = useState(defaultFilter);
  const [teamData, setTeamData] = useState([]);
  const [leagueData, setLeagueData] = useState([]);
  const [fieldData, setFieldData] = useState([]);
  const [matches, setMatches] = useState([]);
  const [selected, setSelected] = useState('regular-date');
  const [tbd, setTbd] = useState({});
  const [loading, setLoading] = useState(true);
  const componentRef = useRef();
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popupContent, setPopupContent] = useState(false);

  useEffect(() => {
    getSports();
    getSeasons();
    getWeekList()
    getRoundList()
    console.log('MASTER SCHEDULER RENDERED');
    //eslint-disable-next-line
  }, []);

  const getSports = async () => {
    axiosApi.get(`${config.apiUrl}/misc/sports`)
      .then((resp) => {
        if (resp && resp.data && resp.data.data) {
          if (resp.data.data && resp.data.data.length) {
            setSportsList([...resp.data.data]);
          }
        }
      })
      .catch((err) => {
      });
  }

  const getSeasons = async () => {
    axiosApi.get(`${config.apiUrl}/seasons`)
      .then((resp) => {
        if (resp && resp.data && resp.data.data) {
          if (resp.data.data && resp.data.data.length) {
            originalSeasons = [...resp.data.data];
            setSeasonsList(originalSeasons);
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  const getWeekList = () => {
    let weeks = [];
    for (let i = 1; i < 16; i++) {
      weeks = [...weeks, ...[{ id: i, title: `Week ${i}` }]];
    }
    setWeekList([...weeks]);
  }

  const getRoundList = () => {
    let round = [];
    for (let i = 1; i < 6; i++) {
      round = [...round, ...[{ id: i, title: `Round ${i}` }]];
    }
    setRoundList([...round]);
  }

  const filterChange = (ele, type) => {
    if (ele) {
      let copyFilter = { ...defaultFilter };
      let newObj = Object.keys(copyFilter)
        .slice(Object.keys(copyFilter).indexOf(type))
        .reduce((a, c) => Object.assign(a, { [c]: copyFilter[c] }), {});

      if (!_.isEmpty(newObj)) {
        newObj = _.omit(newObj, type);
      }
      newObj[type] = ele;
      const updatedFilter = { ...filter, ...newObj };
      setFilter({ ...updatedFilter });

      // Reset locations when week/round/date changes
      if (type === 'week' || type === 'sport' || type === 'season') {
        setSelectedLocations([]);
        setLeagueData([]);
        setTeamData([]);
        setFieldData([]);
        setMatches([]);
      }

      if (type === 'week') {
        getLocation(updatedFilter);
      }
      if (type === 'season' && (selected === 'date' || selected === 'regular-date')) {
        getDate(updatedFilter);
      }
    }
  }

  const checkFilters = (filters, locations) => {
    const activeLocations = locations !== undefined ? locations : selectedLocations;
    const allFiltersSet = Object.keys(filters).every(k => filters[k].id !== 0);
    if (!allFiltersSet || activeLocations.length === 0) {
      setLeagueData([]);
      setTeamData([]);
      setFieldData([]);
      setMatches([]);
      return false;
    }
    const params = {
      sport_id: filters.sport.id,
      season_id: filters.season.id,
      week: filters.week.id,
      location_ids: activeLocations.map(l => l.id),
      leagues_id: leagueIds,
      type: selected
    }
    axiosApi.get(`${config.apiUrl}/leagues/master/schedule`, { params })
      .then((resp) => {
        let leagueData = resp.data.leagueData;
        if (resp.data && resp.data.leagueData) {
          leagueData = [...resp.data.leagueData.map((v, i) => ({ ...v, color: COLORS[i] }))];
        }
        const leagueIds = [].concat.apply([], resp.data.data.map(x => x.schedule.map(y => y.league_id)));
        leagueData = leagueData.filter(x => leagueIds.includes(x.id));
        setLeagueData(leagueData);
        setTeamData([...resp.data.teamData]);
        setFieldData([...resp.data.fields]);
        setMatches([...resp.data.data]);
        if( resp.data.tbd) {
          setTbd(resp.data.tbd);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  const getLocation = (filters) => {
    if (!filters.week.id) {
      setLocationList([]);
      return;
    }
    const params = {
      sport_id: filters.sport.id,
      season_id: filters.season.id,
      week: filters.week.id,
      type: selected
    }
    axiosApi.get(`${config.apiUrl}/leagues/master/schedule/location`, { params })
      .then((resp) => {
        const locationData = resp.data.data.map(l => l.location);
        setLocationList(locationData);
        setLeagueIds([...resp.data.leagueIds]);
      })
      .catch((err) => {
      });
  }

  const getDate = (filters) => {
    const params = {
      sport_id: filters.sport.id,
      season_id: filters.season.id,
      week: filters.week.id,
      type: selected
    }
    axiosApi.get(`${config.apiUrl}/leagues/master/schedule/date`, { params })
      .then((resp) => {
        let locationData = [];
        if (resp.data.data && resp.data.data.length) {
          locationData = resp.data.data.map(l => ({ id: l.date, title: moment(l.date, 'YYYY-MM-DD').format('MM/DD/YYYY') }));
        }
        locationData.forEach((val) => {
          val.timestamp = new Date(val.title).getTime();
        });
        // const temp = _.sortBy(locationData, ['date'])
        setDateList(locationData);
      })
      .catch((err) => {
      });
  }

  const teamName = (id) => {
    let name = '';
    if (id && teamData) {
      const findTeam = teamData.find(x => +x.id === +id);
      if (findTeam) {
        name = `${findTeam.name}`;
      }
    }
    return name;
  }

  const leagueName = (id) => {
    let name = '';
    if (id && leagueData) {
      const findLeague = leagueData.find(x => +x.id === +id);
      if (findLeague) {
        name = `${findLeague.name}`;
      }
    }
    return name;
  }

  const colorCode = (id) => {
    let color = '';
    if (id && leagueData) {
      color = leagueData.find(x => +x.id === +id) ? leagueData.find(x => +x.id === +id).color : '';
    }
    return color;
  }
  const onSortEnd = async (oldIndex, newIndex) => {

    const fieldIds = fieldData.map(y => y.id);
    const sourceIndex = Math.floor(oldIndex / fieldIds.length);
    const destIndex = Math.floor(newIndex / fieldIds.length);
    const items = [...matches];
    if (matches[sourceIndex] && matches[destIndex]) {

      if (sourceIndex === destIndex) {
        if (sourceIndex > 0) {
          oldIndex = Math.ceil(oldIndex % fieldIds.length);
        }
        if (destIndex > 0) {
          newIndex = Math.ceil(newIndex % fieldIds.length);
        }

        
        let teamOrder = [...matches[sourceIndex].schedule];
        const sourceObj = { ...teamOrder[oldIndex] };
        const destObj = { ...teamOrder[newIndex] };

        if(sourceObj.league_id && matches[sourceIndex].time && destObj.field_id) {
          try {
            if(destObj.field_id !==  tbd.id) {
              const response = await checkFieldAndLocation(sourceObj.league_id, matches[sourceIndex].time, destObj.field_id);
              if(response && response.exist !== undefined && !response.exist) {
                toast.hideAll();
                toast.error('Field does not exist in league settings');
                return false;
              }
            }
          } catch(e) {
          }
        }
        if (!_.isEmpty(sourceObj) && !_.isEmpty(destObj)) {
          
          teamOrder[oldIndex].team1_id = destObj.team1_id;
          teamOrder[oldIndex].team2_id = destObj.team2_id;
          teamOrder[oldIndex].league_id = destObj.league_id;
          teamOrder[oldIndex].team1_score = destObj.team1_score;
          teamOrder[oldIndex].team2_score = destObj.team2_score;
          teamOrder[oldIndex].location_id = destObj.location_id;
          teamOrder[oldIndex].id = destObj.id;
          teamOrder[newIndex].team1_id = sourceObj.team1_id;
          teamOrder[newIndex].team2_id = sourceObj.team2_id;
          teamOrder[newIndex].league_id = sourceObj.league_id;
          teamOrder[newIndex].team1_id = sourceObj.team1_id;
          teamOrder[newIndex].team2_score = sourceObj.team2_score;
          teamOrder[newIndex].location_id = sourceObj.location_id;
          
          if (tbd.parent_id === sourceObj.location_id) {
            teamOrder[newIndex].location_id = destObj.location_id;
            teamOrder[oldIndex].location_id = sourceObj.location_id;
          } else if (tbd.parent_id === destObj.location_id) {
            teamOrder[newIndex].location_id = destObj.location_id;
            teamOrder[oldIndex].location_id = sourceObj.location_id;
          }
          if (sourceObj.location_id !== destObj.location_id) {
            teamOrder[newIndex].location_id = destObj.location_id;
            teamOrder[oldIndex].location_id = sourceObj.location_id;
          }
          teamOrder[newIndex].id = sourceObj.id;
          items[sourceIndex].schedule = [...teamOrder];
          setMatches(items);
        }
      } else {
        oldIndex = Math.ceil(oldIndex % fieldIds.length);
        newIndex = Math.ceil(newIndex % fieldIds.length);
        let sourceTeamOrder = [...matches[sourceIndex].schedule];
        let destTeamOrder = [...matches[destIndex].schedule];
        const sourceObj = { ...sourceTeamOrder[oldIndex] };
        const destObj = { ...destTeamOrder[newIndex] };

        if(sourceObj.league_id && matches[destIndex].time && destObj.field_id) {
          try {
            if(tbd.id !== destObj.field_id) {
              const response = await checkFieldAndLocation(sourceObj.league_id, matches[destIndex].time, destObj.field_id);
              if(response && response.exist !== undefined && !response.exist) {
                toast.hideAll();
                toast.error('Field or Time does not exist in league settings');
                return false;
              }
            }
          } catch(e) {
          }
        }
        
        if (!_.isEmpty(sourceObj) && !_.isEmpty(destObj)) {
          sourceTeamOrder[oldIndex].team1_id = destObj.team1_id;
          sourceTeamOrder[oldIndex].team2_id = destObj.team2_id;
          sourceTeamOrder[oldIndex].league_id = destObj.league_id;
          sourceTeamOrder[oldIndex].team1_score = destObj.team1_score;
          sourceTeamOrder[oldIndex].team2_score = destObj.team2_score;
          sourceTeamOrder[oldIndex].location_id = destObj.location_id;
          sourceTeamOrder[oldIndex].id = destObj.id;
          destTeamOrder[newIndex].team1_id = sourceObj.team1_id;
          destTeamOrder[newIndex].team2_id = sourceObj.team2_id;
          destTeamOrder[newIndex].league_id = sourceObj.league_id;
          destTeamOrder[newIndex].team1_score = sourceObj.team1_score;
          destTeamOrder[newIndex].team2_score = sourceObj.team2_score;
          destTeamOrder[newIndex].location_id = sourceObj.location_id;

          if (tbd.parent_id === sourceObj.location_id) {
            destTeamOrder[newIndex].location_id = destObj.location_id;
            sourceTeamOrder[oldIndex].location_id = sourceObj.location_id;
          } else if (tbd.parent_id === destObj.location_id) {
            destTeamOrder[newIndex].location_id = destObj.location_id;
            sourceTeamOrder[oldIndex].location_id = sourceObj.location_id;
          }

          if (sourceObj.location_id !== destObj.location_id) {
            destTeamOrder[newIndex].location_id = destObj.location_id;
            sourceTeamOrder[oldIndex].location_id = sourceObj.location_id;
          }

          destTeamOrder[newIndex].id = sourceObj.id;
          items[sourceIndex].schedule = [...sourceTeamOrder];
          items[destIndex].schedule = [...destTeamOrder];
          setMatches(items);
        }
      }
    }
  }

  const checkFieldAndLocation = (league_id, time, field_id) => {
    return new Promise((resolve, reject) => {
      axiosApi.post(`${config.apiUrl}/misc/check-time-field-exit`, { league_id, time, field_id , tbd: tbd })
        .then((response) => {
          if(response?.data?.data) {
            resolve(response?.data?.data);
          } else {
            reject(false);
          }
        }).catch(err => {
          reject(false);
        })
    })
  }

  const modifyDefaultChecked = (type) => {
    filterChange({ id: 0, title: 'Sport' }, 'sport')
    setSelectedLocations([]);
    setSelected(type);
  }

  const handleLocationToggle = (location) => {
    const isSelected = selectedLocations.some(l => l.id === location.id);
    const next = isSelected
      ? selectedLocations.filter(l => l.id !== location.id)
      : [...selectedLocations, location];
    setSelectedLocations(next);
    checkFilters(filter, next);
  };

  const handleSelectAllLocations = () => {
    setSelectedLocations([...locationList]);
    checkFilters(filter, [...locationList]);
  };

  const handleClearAllLocations = () => {
    setSelectedLocations([]);
    setLeagueData([]);
    setTeamData([]);
    setFieldData([]);
    setMatches([]);
  };

  const updateMasterSchedule = (skip_reschedule_check, send_reschedule_message) => {
    if (matches && matches.length) {
      let schedule = [];
      let copyMatches = _.cloneDeep(matches);
      copyMatches.forEach(match => {
        const updatedSch = match.schedule.filter(sc => (sc.id > 0 && ((sc.team1_id > 0 && sc.team2_id > 0) || ['date', 'round'].includes(selected) && sc.id > 0 )));
        schedule = [...schedule, ...updatedSch.map(sc => ({ id: +sc.id, date: match.originalDate, time: match.originalTime, field_id: sc.field_id, location_id: sc.location_id }))];
      });
      axiosApi.post(`${config.apiUrl}/leagues/master/schedule/bulk/update`, { type: selected, schedule, skip_reschedule_check, send_reschedule_message })
        .then((response) => {
          if (response?.data?.data?.reschedule) {
            if(response?.data?.data?.reschedule) {
              setOpenWarningPopup(true);
              setPopupContent({
                header: 'Confirm',
                description: "Would like to send reschedule message?",
                icon: faExclamationCircle,
                type: 'reschedule',
                action: (res) => {
                  updateMasterSchedule(true, res);
                  setOpenWarningPopup(false);
                }
              });

            }
          }
        }).catch(err => {
        })
    }
  }

  return <>
    <div className="content-wrapper content-wrapper-master schedule-wrapper">
      <div className="inner-wrapper">
        <div className="top-block">
          <div className="heading-block">
            <div className="heading-wrapper">
              {
                <div className="left">
                  <h1 className="heading">Master Schedule</h1>
                  <div className="checkbox-outer">
                    <label className="checkbox">
                      Regular Season by Date
                      <input type="radio" value='regular-date' checked={selected === 'regular-date'} onChange={() => modifyDefaultChecked('regular-date')} />
                      <span className="checkmark"></span>
                    </label>
                    <label className="checkbox">
                      Regular Season by Weeks
                      <input type="radio" value='regular' checked={selected === 'regular'} onChange={() => modifyDefaultChecked('regular')} />
                      <span className="checkmark"></span>
                    </label>
                    <label className="checkbox">
                      Playoffs by Rounds
                      <input type="radio" value='round' checked={selected === 'round'} onChange={() => modifyDefaultChecked('round')} />
                      <span className="checkmark"></span>
                    </label>
                    <label className="checkbox">
                      Playoffs by Date
                      <input type="radio" value='date' checked={selected === 'date'} onChange={() => modifyDefaultChecked('date')} />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </div>
              }
              {(matches?.length > 0 && fieldData?.length > 0) && <div className="right">
                <ReactToPrint
                  trigger={() => <button className="btn btn-primary"><img src={printIcon} alt='print-img' />Print Schedule</button>}
                  content={() => componentRef.current}
                  documentTitle={'Master Schedule'}
                />
              </div>}
            </div>
            <div className={`dropdown-outer cs-resp ${filter?.season?.id > 0 ? 'extend-to-1fr' : ''}`}>
              <div className="dropdown-blk">
                <CustomSelect
                  uniqueKey={`sport-key-${filter?.sport?.id}`}
                  data={sportsList}
                  label={""}
                  placeholder={![null, undefined, '', 0].includes(filter?.sport?.id) ? filter?.sport?.title : 'Select Sport'}
                  type={"sport"}
                  onSelect={(ele) => filterChange(ele, 'sport')}
                  selector="title"
                />
              </div>
              {
                filter?.sport &&
                filter.sport?.id > 0 &&
                <>
                  <div className="dropdown-blk">
                    <CustomSelect
                      uniqueKey={`season-key-${filter?.season?.id}`}
                      data={seasonsList}
                      label={""}
                      placeholder={![null, undefined, '', 0].includes(filter?.season?.id) ? filter?.season?.title : 'Select Season'}
                      type={"season"}
                      onSelect={(ele) => filterChange(ele, 'season')}
                      selector="title"
                    />
                  </div>
                  {
                    filter?.season &&
                    filter.season?.id > 0 &&
                    <>
                      {
                        selected === 'regular' &&
                        <div className="dropdown-blk">
                          <CustomSelect
                            uniqueKey={`week-key-${filter?.week?.id}`}
                            data={weekList}
                            label={""}
                            placeholder={![null, undefined, '', 0].includes(filter?.week?.id) ? filter?.week?.title : 'Select Week'}
                            type={"week"}
                            onSelect={(ele) => filterChange(ele, 'week')}
                            selector="title"
                          />
                        </div>
                      }
                      {
                        selected === 'round' &&
                        <div className="dropdown-blk">
                          <CustomSelect
                            uniqueKey={`round-key-${filter?.week?.id}`}
                            data={roundList}
                            label={""}
                            placeholder={![null, undefined, '', 0].includes(filter?.week?.id) ? filter?.week?.title : 'Select Round'}
                            type={"week"}
                            onSelect={(ele) => filterChange(ele, 'week')}
                            selector="title"
                          />
                        </div>
                      }
                      {
                        (selected === 'date' ||
                        selected === 'regular-date') &&
                        <div className="dropdown-blk">
                          <CustomSelect
                            uniqueKey={`round-key-${filter?.week?.id}`}
                            data={dateList}
                            label={""}
                            placeholder={![null, undefined, '', 0].includes(filter?.week?.id) ? filter?.week?.title : 'Select Date'}
                            type={"week"}
                            onSelect={(ele) => filterChange(ele, 'week')}
                            selector="title"
                          />
                        </div>
                      }
                      {
                        filter?.week &&
                        filter.week?.id !== 0 &&
                        <>
                          <div className="dropdown-blk ms-multiselect-wrapper">
                            {locationDropdownOpen && (
                              <div
                                style={{ position: 'fixed', width: '100%', height: '100%', top: 0, left: 0, zIndex: 9 }}
                                onClick={() => setLocationDropdownOpen(false)}
                              />
                            )}
                            <div
                              id="location_drop_down"
                              className="dropdown-header"
                              onClick={() => setLocationDropdownOpen(o => !o)}
                            >
                              <span>
                                {selectedLocations.length === 0
                                  ? 'Select Location'
                                  : selectedLocations.length === 1
                                    ? selectedLocations[0].title
                                    : `${selectedLocations.length} Locations Selected`}
                              </span>
                              <div className="arrow-blk">
                                <img src={dropdownIcon} alt="dropdown" />
                              </div>
                            </div>
                            {locationDropdownOpen && (
                              <ul className="active ms-multiselect-menu">
                                <li
                                  className="ms-multiselect-select-all"
                                  onClick={() => selectedLocations.length === locationList.length
                                    ? handleClearAllLocations()
                                    : handleSelectAllLocations()
                                  }
                                >
                                  <input
                                    type="checkbox"
                                    readOnly
                                    checked={locationList.length > 0 && selectedLocations.length === locationList.length}
                                  />
                                  <span>{selectedLocations.length === locationList.length ? 'Deselect All' : 'Select All'}</span>
                                </li>
                                {locationList.map((loc, idx) => (
                                  <li
                                    key={`loc-${loc.id}-${idx}`}
                                    className="ms-multiselect-item"
                                    onClick={() => handleLocationToggle(loc)}
                                  >
                                    <input
                                      type="checkbox"
                                      readOnly
                                      checked={selectedLocations.some(l => l.id === loc.id)}
                                    />
                                    <span>{loc.title}</span>
                                  </li>
                                ))}
                                {locationList.length === 0 && (
                                  <li className="noRecord">No data.</li>
                                )}
                              </ul>
                            )}
                          </div>
                        </>
                      }
                    </>
                  }
                </>
              }
            </div>
          </div>
          {/* <div className="clipboard-block">
                        <h2>Clipboard</h2>
                        <div className="team-blk">
                            <div className="inner-blk">
                                Volley want a cracker (0) <br /> Vs. <br /> Ya Dig? (3)
                                <span className="green-blk"></span>
                            </div>
                            <div className="inner-blk">
                                Couples Therapy (0) <br /> Vs. <br /> Notorious D.I.G. (3)
                                <span className="green-blk"></span>
                            </div>
                            <div className="empty-blk">
                            </div>
                        </div>
                    </div> */}
        </div>
        <div className="content-blk">
          {(matches?.length > 0 && fieldData?.length > 0) && <div className="matchup-header">
            <h2>Select a Matchup to input score</h2>
            <div className="btn-blk">
              {/* <button className="btn btn-primary btn-white">Cancel</button> */}
              <button className="btn btn-primary" onClick={() => updateMasterSchedule()}>Save Edits</button>
            </div>
          </div>}
          <div ref={componentRef}>
            <MasterSchedulePrint data={{matches: matches, fields: fieldData, leagues: leagueData, teams: teamData, selected: selected}} />
          </div>
          {(matches?.length > 0 && fieldData?.length > 0) ? <div className="weekly-matchup schedule-create-block" id="divContents">
            <div className="create-schedule-innner">
              <SimpleBarReact className={'sidebarInner-container'}>
                <div className="schedule-create-row headingblock">
                  {
                    fieldData &&
                    fieldData.length > 0 &&
                    <div className="schedule-create-row headingblock">
                      <div className="schedule-create-col col1">
                      </div>
                      {
                        fieldData.map((field, i) => (
                          <div className={`schedule-create-col col${i + 2}`} key={`${field.id}-${i}`}>
                            {field.title}
                          </div>
                        ))
                      }
                    </div>
                  }
                </div>
                <SortableList onSortEnd={onSortEnd} draggedItemClassName="draggableMaster">
                  {
                    matches &&
                    matches.length > 0 &&
                    matches.map(match => (
                      <div className="schedule-create-row row" key={match.id}>
                        <div className="schedule-create-col col1">
                          {match.date} <br />
                          {match.time ? match.time : 'TBD'}
                        </div>
                        {
                          match.schedule &&
                          match.schedule.length &&
                          match.schedule.map((sc, i) => (
                            <SortableItem key={`${sc.field_id}-${i}`}>
                              <div className={`schedule-create-col col2 ${sc?.conflict && sc.team1_id ? 'conflict' : ''}`}>
                                
                                {
                                  ((sc.team1_id > 0 &&
                                  sc.team2_id > 0) || ['date', 'round'].includes(selected) && sc.id > 0) &&
                                  <>
                                    {sc.team1_id ? <>{teamName(sc.team1_id)} ({sc.team1_score ? sc.team1_score : 0})</>: 'TBD' }<br />
                                    Vs. <br />
                                    {
                                      sc.team2_id ? <>{teamName(sc.team2_id)} ({sc.team2_score ? sc.team2_score : 0})</>: 'TBD'
                                    }
                                    <span title={leagueName(sc?.league_id)}  style={{ background: colorCode(sc?.league_id) }}></span>
                                  </>
                                }
                                {
                                  !sc.team1_id &&
                                  !sc.team2_id &&
                                  <span></span>
                                }
                                {
                                  sc.leagueIds && !sc.team1_id && !sc.team2_id && (['date', 'round'].includes(selected) && !sc.id || !['date', 'round'].includes(selected)) && <div className="cs-league-dots">
                                    {
                                      sc.leagueIds.map((leagueid, lk) => {
                                        if(leagueData.find(x => x.id === leagueid)) {
                                          return <em key={lk} className="color-code"  title={leagueName(leagueid)} style={{ background: colorCode(leagueid) }}></em>
                                        } else {
                                          return null;
                                        }
                                        
                                      })
                                    }
                                  </div>
                                }
                              </div>
                            </SortableItem>
                          ))
                        }
                      </div>
                    ))
                  }
                </SortableList>

              </SimpleBarReact>
            </div>
            {
              leagueData &&
              leagueData.length > 0 &&
              <div className="team-blk">
                {
                  leagueData.map(league => (
                    <div className="inner-row" key={league.id}>
                      <div className="inner-blk">
                        <span style={{ background: colorCode(league?.id) }}></span>
                        <p>{leagueName(league.id)}</p>
                      </div>
                    </div>
                  ))
                }
              </div>
            }
            <WarningDialogue
            isOpen={openWarningPopup}
            header={popupContent.header}
            description={popupContent.description}
            icon={popupContent.icon}
            action={popupContent.action}
            type={popupContent?.type || ''}
            onClose={() => setOpenWarningPopup(false)}
          />
          </div> : (!loading && <div className="noRecord-found-classifieds">No schedule found</div>)}
        </div>
      </div>
    </div>
  </>
}